import { DefaultIcon, assignSafe } from '@summit/core';

export class SummitAction {
  id?: string | number | null;
  name?: string;
  icon?: DefaultIcon;
  grid?: unknown;

  constructor(jsonData?: Partial<SummitAction>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
